import { useMemo } from "react";
import { toJSON } from "../../../../../_metronic/assets/ts/_utils";


export const ADMIN_COMMENT_FIELDS = {
  adminReview: 'Admin Review',
  docuReview: 'Document Review',
  certFee: 'Cert Fee',
  factAudit: 'Factory Audit',
  sampling: 'Sampling',
  suvTest: 'Surveillance Test',
  others: 'Others',
};


type Props = {
  adminComment: string
}

export const AdminComment = ({adminComment} : Props) => {

  const commentFields = useMemo(() => {
    return toJSON(adminComment);
  }, [adminComment]);

  if (! adminComment) {
    return null;
  }

  if (! commentFields) {
    return (
      <div className='flex-grow-1 text-gray-800 fs-7 lh-sm' style={{whiteSpace: 'pre-line'}}>
        {`${adminComment}`}&nbsp;
      </div >
    ) 
  }

  return Object.entries(commentFields).map(vals => (
    <div className='row' key={vals[0]}>
      <label className="col-sm-4 fw-bold text-muted fs-7">
      {(ADMIN_COMMENT_FIELDS.hasOwnProperty(vals[0]) ? (
        ADMIN_COMMENT_FIELDS[vals[0] as keyof typeof ADMIN_COMMENT_FIELDS]       
      ) : (
        vals[0]
      ))}
      </label>
      <div className='col-sm-8'>        
        <span className='fw-bolder fs-7 text-dark lh-sm' style={{whiteSpace: 'pre-line'}}>{`${vals[1]}`}</span>        
      </div>
    </div>      
  ))
}